module.exports = __webpack_public_path__ + "assets/training-item-remove.fd2b8a69.svg";